var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback, useMemo } from 'react';
import { analyticsApi } from 'apis/analytics';
import { useAppSelector } from 'utils/redux/useAppSelector';
/** A hook that selects the instrument query state for each comparate. */
export const useComparisonInstrumentsQueryState = () => {
    const left = useAppSelector(selectLeftComparate);
    const right = useAppSelector(selectRightComparate);
    const transformSelectResult = useCallback((_a) => {
        var _b;
        var { data } = _a, rest = __rest(_a, ["data"]);
        return (Object.assign(Object.assign({}, rest), { instruments: (_b = data === null || data === void 0 ? void 0 : data.data.instruments) !== null && _b !== void 0 ? _b : [] }));
    }, []);
    return useMemo(() => ({
        left: transformSelectResult(left),
        right: transformSelectResult(right),
    }), [left, right, transformSelectResult]);
};
const selectComparate = (side) => analyticsApi.endpoints.readComparisonInstruments.select({
    side,
    payload: null,
});
const selectLeftComparate = selectComparate('left');
const selectRightComparate = selectComparate('right');
